/** Logo bug (logomark) URL – display with text "Mujeres y Riquezas" */
export const LOGO_BUG_URL = 'https://media.publit.io/file/ProsperityLeaders/myr-logo-bug.png';
